module.exports = __webpack_public_path__ + "static/media/m-movies.88cd2f0c.svg";